import sanitize from 'sanitize-filename';

export const sanitizeFilename = (input: string): string => {
  return sanitize(input, {
    replacement: '-',
  });
};

export const transformOrcidInput = (input: string): string => {
  const cleanedInput = input.trim();
  const orcidPattern = /^\d{4}-\d{4}-\d{4}-\d{3}[0-9X]$/;

  if (orcidPattern.test(cleanedInput)) {
    return `https://orcid.org/${cleanedInput}`;
  }
  return cleanedInput;
};

export const formatDoiInput = (input: string): string => {
  if (typeof input !== 'string') {
    return input;
  }
  const cleanedInput = input.trim();
  const doiUrlPattern =
    /^https?:\/\/(dx\.)?doi\.org\/(10\.\d{4,9}\/[-._;()\/a-zA-Z0-9]+)$/i;

  const match = doiUrlPattern.exec(cleanedInput);
  if (match) {
    return match[2];
  }

  return cleanedInput;
};

export const autoFormatISSN = (input: string): string => {
  if (!input) return '';

  const cleanedInput = input.trim().replace(/[^0-9Xx]/gi, '');

  if (/^[\d]{7}[\dXx]$/i.test(cleanedInput)) {
    const normalizedIssn =
      cleanedInput.slice(0, 7) + cleanedInput.slice(7).toUpperCase();
    return `${normalizedIssn.slice(0, 4)}-${normalizedIssn.slice(4)}`;
  }

  return input.trim();
};

export const escapeRegex = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

